export { PageItemType as DynamicPageItemType } from '@src/api/enums/pageItemType';
